import React from "react";

const Separator = ({ separator_type = "normal" }) => {
	return <hr className={`donate-field__separator ${separator_type}`} />;
};

export default Separator;
